__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ue-rendering-platform";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.14.1", () => (() => (__webpack_require__(6758))), 1);
			register("@bolt/components", "2.5.6", () => (() => (__webpack_require__(6616))), 1);
			register("@bolt/foundations", "1.15.2", () => (() => (__webpack_require__(1148))), 1);
			register("@ue/authentication", "0.10.2", () => (__webpack_require__.e(9595).then(() => (() => (__webpack_require__(9595))))));
			register("@ue/commons", "1.100.3", () => (() => (__webpack_require__(4876))), 1);
			register("@ue/events", "1.31.0", () => (__webpack_require__.e(1553).then(() => (() => (__webpack_require__(1553))))));
			register("@ue/experience-context", "1.4.1", () => (() => (__webpack_require__(5941))), 1);
			register("@ue/i18n", "0.6.4", () => (() => (__webpack_require__(6763))), 1);
			register("@ue/navigation", "1.2.7", () => (() => (__webpack_require__(6068))), 1);
			register("apollo-link-rest", "0.9.0", () => (__webpack_require__.e(9880).then(() => (() => (__webpack_require__(9880))))));
			register("date-fns-tz", "0", () => (__webpack_require__.e(7971).then(() => (() => (__webpack_require__(7971))))));
			register("graphql", "16.14.0", () => (() => (__webpack_require__(1547))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-router-dom", "6.30.6", () => (() => (__webpack_require__(2648))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			register("uuid", "11.1.1", () => (__webpack_require__.e(3221).then(() => (() => (__webpack_require__(3221))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};